import React from 'react';
import classNames from 'classnames';
/**
 * Normalize non `de` ratings to comply with the new German legislation.
 */
export const normalizeRatingClasses = (ratingClass, scope = 'eu') => {
    if (scope === 'eu') {
        return ratingClass;
    }
    else if (scope === 'de') {
        if (ratingClass === 'a+++' || ratingClass === 'a++' || ratingClass === 'a+') {
            return 'a';
        }
        else {
            return ratingClass;
        }
    }
};
/**
 * Bronson Efficiency Tag component.
 *
 * @see https://bronson.vwfs.io/default/components/detail/bronson-efficiency-tag.html
 *
 * @constructor
 */
export function EfficiencyTag({ className, label, pointer, rating, scope = 'eu', testId, ...otherProps }) {
    const classNameList = classNames('c-efficiency-tag', {
        'c-efficiency-tag--pointer': pointer,
    }, className).trim();
    return (React.createElement("span", { className: classNameList, "data-efficiency-tag": pointer || label ? null : normalizeRatingClasses(rating, scope), "data-efficiency-tag-scope": pointer || label ? null : scope, "data-testid": testId, ...otherProps }, label ?? rating?.toUpperCase()));
}
